<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search_name"
          placeholder="请输入联系人或联系电话"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" icon="ios-download" @click="exportAll">下载所有名单</Button>
    </div>
    <div class="table">
      <Tabs type="card" v-model="search.status" @on-click="searchFn">
        <TabPane name="all" label="全部"></TabPane>
        <TabPane name="0" label="审核中"></TabPane>
        <TabPane name="1" label="审核通过"></TabPane>
        <TabPane name="2" label="审核不通过"></TabPane>
      </Tabs>
    </div>
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    <!-- 编辑信息 -->
    <edit-user v-model="diyDom.showEdit" :id="diyData.id" @on-success="editUserSucc"></edit-user>
    <!-- 审核 -->
    <inspectModal v-model="diyDom.showInspect" :id="diyData.id" @on-success="getTableList"></inspectModal>
  </div>
</template>

<script>
  import editUser from './edit-user.vue'
  import inspectModal from './inspect-modal.vue'
  import * as apiActivities from '@/api/activity/activity'
  import downloadBlob from '@/utils/downloadBlob'
  export default {
    name: 'signup-list',
    components: {
      editUser,
      inspectModal,
    },
    data() {
      return {
        query: {},
        search: {
          status:'all',
          search_name: '',
          page: 1,
        },
        diyDom: {
          showUpload: false,
          showEdit: false,
          showInspect: false,
        },
        diyData: {
          id: '',
          columns: [
            {
              title: 'ID',
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              title: '联系人',
              key: 'contact_name',
            },
            {
              title: '联系电话',
              key: 'contact_mobile',
            },
            {
              title: '报名时间',
              key: 'created_at',
            },
            {
              title: '更新时间',
              key: 'updated_at',
            },
            {
              title: '审核状态',
              key: 'status_lab',
            },
            {
              title: '审核备注',
              key: 'remark',
            },
            {
              title: '操作',
              fixed: 'right',
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showEdit = true
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showInspect = true
                        },
                      },
                    },
                    '审核'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.$store.commit('setSpinShow', true)
                          apiActivities.apiActivitiesExportSingle(params.row.id,{
                            t:new Date().getTime()
                          }).then(res =>{
                            downloadBlob(res)
                          }).finally(() => this.$store.commit('setSpinShow', false))
                        },
                      },
                    },
                    '导出'
                  ),
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          per_page: 0,
          tableList: [],
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiActivities
          .apiActivitiesSignList({ ...this.search, ...this.query })
          .then(res => {
            const { data, meta } = res
            this.apiData.tableList = data
            this.apiData.per_page = meta.pagination.per_page
            this.apiData.total = meta.pagination.total
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      // 清空
      clearFn() {
        this.search = {
          search_name: '',
          page: 1,
        }
        this.getTableList()
      },
      // 编辑信息成功
      editUserSucc() {
        this.getTableList()
      },
      // 导出所有
      exportAll() {
        this.$store.commit('setSpinShow', true)
        apiActivities.apiActivitiesExportAll(this.query.act_id,{
          t:new Date().getTime()
        }).then(res => {
          downloadBlob(res)
        }).finally(() => this.$store.commit('setSpinShow', false))
      },
    },
    mounted() {
      this.query = this.$route.query
      this.getTableList()
    },
  }
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
  .upload-modal {
    padding: 40px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .tips {
      margin-top: 10px;
    }
  }
</style>
